import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { api } from '../lib/api';
/** How many Help & Feedback requests have a reply the parent hasn't opened: checked on each page change and every few minutes (#414). */
export function useSupportUnread() {
  const { pathname } = useLocation();
  const [count, setCount] = useState(0);
  useEffect(() => {
    let live = true;
    const check = () =>
      api
        .get<{ count: number }>('/api/support/unread')
        .then((r) => live && setCount(r.count))
        .catch(() => undefined);
    void check();
    const timer = setInterval(check, 3 * 60_000);
    return () => {
      live = false;
      clearInterval(timer);
    };
  }, [pathname]);
  return count;
}
